import { useTranslation } from 'react-i18next'

import { Icon, Menu } from '@percent/lemonade'

export type TemplateActionsMenuProps = {
  canManage: boolean
  canEdit: boolean
  canArchive: boolean
  canSetDefault: boolean
  canRemoveDefault: boolean
  onEdit: VoidFunction
  onArchive: VoidFunction
  onSetDefault: VoidFunction
  onRemoveDefault: VoidFunction
}

export function TemplateActionsMenu({
  canManage,
  canEdit,
  canArchive,
  canSetDefault,
  canRemoveDefault,
  onEdit,
  onArchive,
  onSetDefault,
  onRemoveDefault
}: Readonly<TemplateActionsMenuProps>) {
  const { t } = useTranslation()

  if (!canManage) {
    return null
  }

  const menuItems = [
    ...(canEdit ? [{ key: 'edit', label: t('dialog.templates.edit'), dataTestId: 'edit-template-menu-item' }] : []),
    ...(canSetDefault
      ? [
          {
            key: 'setDefault',
            label: t('dialog.templates.setDefault'),
            dataTestId: 'set-default-template-menu-item'
          }
        ]
      : []),
    ...(canRemoveDefault
      ? [
          {
            key: 'removeDefault',
            label: t('dialog.templates.removeDefault'),
            dataTestId: 'remove-default-template-menu-item'
          }
        ]
      : []),
    ...(canArchive
      ? [
          {
            key: 'archive',
            label: t('dialog.templates.archive'),
            withSeparator: true,
            dataTestId: 'archive-template-menu-item'
          }
        ]
      : [])
  ]

  const handleMenuSelect = (actionKey: string) => {
    if (actionKey === 'edit') {
      onEdit()
    }

    if (actionKey === 'setDefault') {
      onSetDefault()
    }

    if (actionKey === 'removeDefault') {
      onRemoveDefault()
    }

    if (actionKey === 'archive') {
      onArchive()
    }
  }

  return (
    <Menu
      title={<Icon name="menu-vertical" size={6} />}
      sections={[{ items: menuItems }]}
      onSelect={handleMenuSelect}
    />
  )
}
